import React, { useCallback } from 'react'
import noop from 'lodash/noop'
import {
    FormControlLabel,
    Checkbox as MaterialCheckbox,
} from '@mui/material'
import { SerializedStyles } from '@emotion/react'

type Props = {
    title?: string;
    disabled?: boolean;
    indeterminate?: boolean;
    onChange?: (value: boolean, event: { target: { name: string; value: boolean } }) => void;
    name?: string;
    value?: boolean;
    customCss?: SerializedStyles;
}

const Checkbox = ({
    title = '',
    disabled = false,
    indeterminate = false,
    onChange = noop,
    name = '',
    value = false,
    customCss,
}: Readonly<Props>) => {
    const handleChange = useCallback(() => {
        const newValue = !value

        onChange(newValue, { target: {
            name,
            value: newValue,
        } })
    }, [
        name,
        onChange,
        value,
    ])

    return (
        <div css={customCss}>
            <FormControlLabel
                control={
                    (
                        <MaterialCheckbox
                            data-testid={`checkbox-${name}`}
                            disabled={disabled}
                            checked={value}
                            color="primary"
                            indeterminate={indeterminate}
                            onChange={handleChange}
                            value={value}
                            name={name}
                        />
                    )
                }
                label={title}
            />
        </div>
    )
}

export default Checkbox
